export const getIsEvo = (baseUrl) => {
    return (baseUrl || "").includes("evo");
};
export const sanitizeBaseUrl = (baseUrl) => {
    if (typeof baseUrl !== "string") {
        console.warn("sanitizeBaseUrl: baseUrl is not a string, returning empty string instead.");
        return "";
    }
    return baseUrl.endsWith("/api") ? baseUrl.slice(0, -4) : baseUrl;
};
//# sourceMappingURL=evo.js.map